import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  Stats,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import bg from "../img/bg.mp4";
import { useNavigate } from "react-router";
import { Grid } from "@mui/material";
import { FeatureCard } from "../components/Hero";
import { FeatureCardSmall } from "../components/Hero";
import CellTowerIcon from "@mui/icons-material/CellTower";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import BiotechIcon from "@mui/icons-material/Biotech";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import HotelIcon from "@mui/icons-material/Hotel";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import WorkIcon from "@mui/icons-material/Work";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import BuildIcon from "@mui/icons-material/Build";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PersonIcon from "@mui/icons-material/Person";
import Lottie from "react-lottie";
import { Tailor } from "./Sections";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore"; // For Logistics
import MedicalServicesIcon from "@mui/icons-material/MedicalServices"; // For Healthcare
import FlightIcon from "@mui/icons-material/Flight"; // For Travel
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar"; // For Automotive
import SchoolIcon from "@mui/icons-material/School"; // For Education
import PeopleIcon from "@mui/icons-material/People"; // For Human Resources
import SpaIcon from "@mui/icons-material/Spa"; // Wellness
import PeopleAltIcon from "@mui/icons-material/PeopleAlt"; // Social Networking
import MovieIcon from "@mui/icons-material/Movie"; // Entertainment
import RestaurantIcon from "@mui/icons-material/Restaurant"; // Restaurant
import CloudIcon from "@mui/icons-material/Cloud"; // SaaS
import GavelIcon from "@mui/icons-material/Gavel"; // Politics
import HomeIcon from "@mui/icons-material/Home"; // Real Estate
import ElectricCarIcon from "@mui/icons-material/ElectricCar";

export default function WhatWeDo() {
  useEffect(() => {
    axios.get(API_URL + "get_news").then((res) => {
      setNews(res.data);
    });
  }, []);
  const [news, setNews] = useState([]);
  const navigate = useNavigate();

  const Industry = (props) => {
    return (
      <Grid
        item
        md={6}
        xs={12}
        sm={12}
        style={{
          width: "100%",
          textAlign: "left",
          display: "flex",
          justifyContent: "start",
          flexDirection: "column",
          alignItems: "start",
        }}
      >
        <img
          style={{ width: "100%", borderRadius: "25px" }}
          src={props.image}
        />
        <div
          style={{
            marginTop: "25px",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: "75px",
              width: "75px",
              borderRadius: "15px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: themeStyle.primaryColor,
            }}
          >
            {props.icon}
          </div>
          <div
            style={{
              display: "flex",
              color: "white",
              fontWeight: 600,
              fontSize: "20px",
              marginTop: "15px",
              marginBottom: "15px",
              marginLeft: "15px",
            }}
          >
            {props.title}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            color: "white",
            fontSize: "18px",
            marginTop: "15px",
            marginBottom: "15px",
            textAlign: "justify",
          }}
        >
          {props.subtitle}
        </div>
      </Grid>
    );
  };

  const Industry2 = (props) => {
    return (
      <Grid
        item
        md={4}
        xs={12}
        sm={12}
        style={{
          width: "100%",
          textAlign: "left",
          display: "flex",
          justifyContent: "start",
          flexDirection: "column",
          alignItems: "start",
        }}
      >
        <img
          style={{ width: "100%", borderRadius: "15px" }}
          src={props.image}
        />
        <div
          style={{
            marginTop: "25px",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: "75px",
              width: "75px",
              borderRadius: "15px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: themeStyle.primaryColor,
            }}
          >
            {props.icon}
          </div>
          <div
            style={{
              display: "flex",
              color: "white",
              fontWeight: 600,
              fontSize: "20px",
              marginTop: "15px",
              marginBottom: "15px",
              marginLeft: "15px",
            }}
          >
            {props.title}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            color: "white",
            fontSize: "18px",
            marginTop: "15px",
            marginBottom: "15px",
            textAlign: "justify",
          }}
        >
          {props.subtitle}
        </div>
      </Grid>
    );
  };

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="anigrad" style={{ backgroundColor: "white" }}>
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "50px",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: 600,
                  marginTop: state.auth.isMobile ? "0px" : "75px",
                }}
              >
                Preferred Transformation partner of Global Leaders
              </div>

              <div
                style={{
                  fontSize: "30px",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                Food, Blockchain, Ecommerce, Healthcare and many more...
              </div>
              <button
                style={{ marginTop: "50px", filter: "invert(0)" }}
                onClick={() => {
                  navigate("/contact");
                }}
                className="squishy"
              >
                Contact Us
              </button>
              {!state.auth.isMobile ? (
                <Tailor
                  invert
                  title1="Industry-Specific"
                  subtitle1="Customized solutions designed for your sector."
                  title2="Results-Driven"
                  subtitle2="Strategies crafted to achieve measurable outcomes."
                  title3="User-Friendly"
                  subtitle3="Intuitive tools for seamless integration and management."
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            backgroundColor: "#222",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "75px",
            paddingBottom: "75px",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "40px",
              color: "white",
              zIndex: 999,
              textAlign: "left",
              marginBottom: "55px",
              fontWeight: 600,
            }}
          >
            The Industries We Work For
          </div>

          <Grid
            style={{
              width: state.auth.isMobile ? "100%" : "90%",
              display: "flex",
              justifyContent: "center",
            }}
            container
            spacing={10}
          >
            <Industry
              title={"Financial Services"}
              image={
                "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              }
              subtitle={
                "We develop secure financial software, including AI/ML-enabled fraud detection systems, investment analytics platforms, and blockchain-based solutions, empowering businesses to operate efficiently and securely."
              }
              icon={
                <AccountBalanceIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                  }}
                />
              }
            />
            <Industry
              title={"Logistics"}
              image={
                "https://images.unsplash.com/photo-1606964212858-c215029db704?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              }
              subtitle={
                "We Develop Cutting-edge softwar efor th elogistics Industry including supply chain software with AI?ML enabled predictive  analytics, helping them serve accross the globe"
              }
              icon={
                <TravelExploreIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                  }}
                />
              }
            />
            {/* Healthcare */}
            <Industry
              title={"Healthcare"}
              image={
                "https://images.unsplash.com/photo-1478476868527-002ae3f3e159?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              }
              subtitle={
                "We develop advanced software solutions for the healthcare industry, including AI/ML-powered diagnostic tools, patient management systems, and telemedicine platforms, enabling better care delivery worldwide."
              }
              icon={
                <MedicalServicesIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                  }}
                />
              }
            />

            {/* Travel */}
            <Industry
              title={"Hospitality & Travel"}
              image={
                "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              }
              subtitle={
                "We create innovative software for the travel industry, including AI-driven booking platforms, itinerary optimization tools, and real-time travel analytics, helping businesses deliver seamless global experiences."
              }
              icon={
                <FlightIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                  }}
                />
              }
            />

            {/* Ecommerce */}
            <Industry
              title={"Ecommerce"}
              image={
                "https://images.unsplash.com/photo-1563013544-824ae1b704d3?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              }
              subtitle={
                "We build scalable ecommerce solutions with AI/ML-powered recommendation engines, inventory management systems, and personalized shopping experiences, driving growth for online businesses worldwide."
              }
              icon={
                <ShoppingCartIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                  }}
                />
              }
            />

            {/* Automotive */}
            <Industry
              title={"Automotive"}
              image={
                "https://images.unsplash.com/photo-1578991132108-16c5296b63dc?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              }
              subtitle={
                "We design cutting-edge software for the automotive industry, including AI-driven autonomous vehicle systems, predictive maintenance tools, and connected car platforms, revolutionizing mobility solutions."
              }
              icon={
                <DirectionsCarIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                  }}
                />
              }
            />

            {/* Education */}
            <Industry
              title={"Education"}
              image={
                "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              }
              subtitle={
                "We create transformative software for the education sector, including AI-powered learning management systems, virtual classrooms, and personalized learning platforms, enhancing global access to quality education."
              }
              icon={
                <SchoolIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                  }}
                />
              }
            />

            {/* Human Resources */}
            <Industry
              title={"Human Resources"}
              image={
                "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              }
              subtitle={
                "We develop intelligent HR software, including AI/ML-driven recruitment tools, employee engagement platforms, and performance analytics systems, helping organizations build and manage top talent."
              }
              icon={
                <PeopleIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                  }}
                />
              }
            />
          </Grid>
        </div>
        <div style={{ backgroundColor: "white" }}>
          <div
            className="anigrad"
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                borderRadius: "25px",
                fontSize: state.auth.isMobile ? "30px" : "40px",
                color: "white",
                fontWeight: 600,
                paddingTop: "50px",
              }}
            >
              Who We Serve
            </div>
            <div style={{ height: "50px" }} />
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Grid
                style={{
                  width: state.auth.isMobile ? "100%" : "70%",
                  display: "flex",
                  justifyContent: "center",
                }}
                container
                spacing={3}
              >
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <FeatureCardSmall
                    title={"Life Science"}
                    text={""}
                    icon={
                      <BiotechIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Manufacturing"}
                    text={""}
                    icon={
                      <PrecisionManufacturingIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"BFSI"}
                    text={""}
                    icon={
                      <AttachMoneyIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Healthcare"}
                    text={""}
                    icon={
                      <LocalHospitalIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
              </Grid>
            </div>
            <div style={{ height: "50px" }} />

            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Grid
                style={{
                  width: state.auth.isMobile ? "100%" : "70%",
                  display: "flex",
                  justifyContent: "center",
                }}
                container
                spacing={3}
              >
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <FeatureCardSmall
                    title={"Oil and Gas"}
                    text={""}
                    icon={
                      <LocalGasStationIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Energy and Utilitites"}
                    text={""}
                    icon={
                      <AccountBalanceIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Retail"}
                    text={""}
                    icon={
                      <ShoppingCartIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Telecom"}
                    text={""}
                    icon={
                      <CellTowerIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
              </Grid>
            </div>
            <div style={{ height: "50px" }} />
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Grid
                style={{
                  width: state.auth.isMobile ? "100%" : "70%",
                  display: "flex",
                  justifyContent: "center",
                }}
                container
                spacing={3}
              >
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <FeatureCardSmall
                    title={"Mining"}
                    text={""}
                    icon={
                      <EngineeringIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Aviation"}
                    text={""}
                    icon={
                      <FlightIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Hospitality"}
                    text={""}
                    icon={
                      <HotelIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"SC&LM"}
                    text={""}
                    icon={
                      <LocalShippingIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
              </Grid>
            </div>
            <div style={{ height: "50px" }} />
          </div>
          <div
            style={{
              backgroundColor: "#222",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "50px",
              paddingBottom: "75px",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                fontSize: state.auth.isMobile ? "30px" : "40px",
                color: "white",
                zIndex: 999,
                textAlign: "left",
                marginBottom: "55px",
                fontWeight: 600,
              }}
            >
              Our expertise also reaches out to
            </div>
            <Grid
              style={{
                width: state.auth.isMobile ? "100%" : "90%",
                display: "flex",
                justifyContent: "center",
              }}
              container
              spacing={3}
            >
              <Industry2
                title={"Electric Vehicle"}
                image={
                  "https://images.unsplash.com/photo-1567409378873-888d6fa7debc?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                }
                subtitle={
                  "We Build Cutting-edge Software for the Electric Vehicle Industry, including AI-powered charging station locators and predictive analytics for energy management."
                }
                icon={
                  <ElectricCarIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                    }}
                  />
                }
              />
              <Industry2
                title={"Real Estate"}
                image={
                  "https://images.unsplash.com/photo-1592595896551-12b371d546d5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                }
                subtitle={
                  "We Create Intelligent Real Estate Solutions, including property management platforms and AI-enabled market analytics for informed decision-making."
                }
                icon={
                  <HomeIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                    }}
                  />
                }
              />
              <Industry2
                title={"Politics"}
                image={
                  "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                }
                subtitle={
                  "We Develop Innovative Political Platforms for data-driven campaign management, voter engagement, and AI-powered sentiment analysis."
                }
                icon={
                  <GavelIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                    }}
                  />
                }
              />

              <Industry2
                title={"SaaS"}
                image={
                  "https://images.unsplash.com/photo-1590971862391-06cac0657603?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                }
                subtitle={
                  "We Build Scalable SaaS Solutions that offer seamless cloud-based services, advanced analytics, and subscription-based business models for diverse industries."
                }
                icon={
                  <CloudIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                    }}
                  />
                }
              />
              <Industry2
                title={"Restaurant"}
                image={
                  "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                }
                subtitle={
                  "We Create Cutting-edge Restaurant Solutions, including AI-enabled table reservation systems, POS integrations, and customer engagement platforms to optimize operations."
                }
                icon={
                  <RestaurantIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                    }}
                  />
                }
              />
              <Industry2
                title={"Entertainment"}
                image={
                  "https://images.unsplash.com/photo-1603190287605-e6ade32fa852?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                }
                subtitle={
                  "We Develop Engaging Entertainment Platforms, including streaming services and interactive applications, using AI-driven content curation and immersive media technologies."
                }
                icon={
                  <MovieIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                    }}
                  />
                }
              />
            </Grid>
          </div>
          <div
            style={{
              padding: state.auth.isMobile ? "18px" : "200px",
              fontSize: state.auth.isMobile ? "30px" : "40px",
              marginBottom: state.auth.isMobile ? "10px" : "-100px",
              marginTop: state.auth.isMobile ? "0px" : "-100px",
              color: "black",
              zIndex: 999,
              fontWeight: 600,
            }}
          >
            Who we have been working for and our expertise
          </div>
          <div style={{ marginLeft: state.auth.isMobile ? "25px" : "0px" }}>
            <ThreeSideBySide
              title1="For Startups"
              subtitle1={
                <div
                  style={{
                    textAlign: "left",
                    fontSize: "18px",
                    fontWeight: "normal",
                  }}
                >
                  Ensure your startup's growth with a strong technical foundation, 
                  designed for scalability, reliability, and long-term success. 
                  Our robust tech stack and expertly crafted systems empower 
                  your product to seamlessly handle increasing user demand without 
                  compromising on performance.
                </div>
              }
              title2="For Businesses"
              subtitle2={
                <div
                  style={{
                    textAlign: "left",
                    fontSize: "18px",
                    fontWeight: "normal",
                  }}
                >
                  Achieve greater scalability, automation, and enhanced productivity to stay competitive 
                  and meet growing demands. By leveraging advanced technologies and streamlined processes, 
                  your business can operate efficiently, reduce manual effort, and thrive in a dynamic market.
                </div>
              }
              title3="For Enterprises & Startups"
              subtitle3={
                <div
                  style={{
                    textAlign: "left",
                    fontSize: "18px",
                    fontWeight: "normal",
                  }}
                >
                  Ensure ecosystem stability and efficiency with continuous delivery and integration, 
                  allowing for seamless updates and faster time-to-market. By automating testing, deployment,
                  and monitoring, you can maintain system reliability and reduce errors.
                </div>
              }
              image1={require("../img/cloud7.png")}
              image2={require("../img/cloud8.png")}
              image3={require("../img/cloud9.png")}
            />
          </div>
          <div style={{ marginBottom: "-50px" }} />
          <ContentSideBySideInv
            title="Our Approach"
            subtitle={
              <div style={{ marginLeft: "15px" }}>
                At CGT Solutions, we distinguish ourselves as your go-to partner for IT solutions 
                by blending innovation, expertise, and a customer-centric approach. 
                Our customized strategies ensure the seamless integration of technology 
                with your business needs, optimizing both efficiency and productivity. 
                Backed by a team of skilled professionals, we deliver scalable, cost-effective 
                solutions designed to adapt to your growth. Whether it’s workforce management 
                or cutting-edge IT support, CGT Solutions empowers your organization to excel in 
                today’s competitive landscape.
              </div>
            }
            image={
              <img
                style={{ width: "100%", marginTop: "15px" }}
                src={require("../img/222.jpg")}
              />
            }
          />
          <div style={{ height: "100px" }} />
        </div>

        <div
          style={{
            fontSize: "30px",
            color: themeStyle.primaryColor,
            zIndex: 999,
            backgroundColor: "white",
            fontWeight: "600",
          }}
        >
          Get To Know Us Better
        </div>
        <Stats />
        <SpacerV height={"100px"} />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
